import React, { Dispatch, SetStateAction } from 'react';

import { isDayjs } from 'dayjs';
import { UseFormSetValue } from 'react-hook-form';
import dayjs from '~/timeInit';

import { DateRangePicker } from '@mui/x-date-pickers-pro';

import { formatDateSlashes } from '~/services/TimeService';

import { DateRange, FormInput } from '../RMChangeLog';

type FormKey =
  | 'propertyName'
  | 'roomTypeName'
  | 'actionedDateRange'
  | 'status'
  | 'actionedDateRange.start'
  | 'actionedDateRange.end';

interface Props {
  dateRangeFormKey: FormKey;
  setDateRangeValue: UseFormSetValue<FormInput>;
  displayDateRange: DateRange;
  setDisplayDateRange: Dispatch<SetStateAction<DateRange>>;
}
export default function SearchDateRange({
  dateRangeFormKey,
  setDateRangeValue,
  displayDateRange,
  setDisplayDateRange,
}: Props) {
  const handleDefaultValue = (dateValue: string) => {
    if (!dateValue) {
      return dayjs();
    }
    return dayjs(dateValue, 'DD/MM/YYYY');
  };
  const isValidDate = (d: any) => isDayjs(d) && d.isValid();
  const handleDateChange = (newValue: [dayjs.Dayjs | null, dayjs.Dayjs | null]) => {
    if (!isValidDate(newValue[0]) || !isValidDate(newValue[1])) {
      return;
    }
    setDisplayDateRange({
      start: formatDateSlashes(newValue[0].toDate()),
      end: formatDateSlashes(newValue[1].toDate()),
    });
    const newValueStartString = newValue[0].startOf('day').utc().format();
    const newValueEndString = newValue[1].endOf('day').utc().format();
    setDateRangeValue(dateRangeFormKey, { start: newValueStartString, end: newValueEndString });
  };
  return (
    <DateRangePicker
      slotProps={{
        textField: {
          error: false,
        },
      }}
      value={[handleDefaultValue(displayDateRange.start), handleDefaultValue(displayDateRange.end)]}
      onChange={(newValue) => handleDateChange(newValue)}
    />
  );
}
